/** マスタ管理(管理者のみ)。事業部・科目・ユーザー・承認ルール・設定をタブで切り替える */
import { useState } from 'react';
import DepartmentsTab from './DepartmentsTab';
import HierarchyTab from './HierarchyTab';
import PermissionsTab from './PermissionsTab';
import CompaniesTab from './CompaniesTab';
import VendorsTab from './VendorsTab';
import PaymentAccountsTab from './PaymentAccountsTab';
import AccountsTab from './AccountsTab';
import UsersTab from './UsersTab';
import ApprovalRulesTab from './ApprovalRulesTab';
import SettingsTab from './SettingsTab';
import { useMasters } from './MastersProvider';

const TABS = [
  { key: 'accounts', label: '勘定科目' },
  { key: 'users', label: 'ユーザー' },
  { key: 'vendors', label: '取引先' },
  { key: 'payment_accounts', label: '支払い方法' },
  { key: 'permissions', label: '権限' },
  { key: 'departments', label: '事業部' },
  { key: 'hierarchy', label: '階層' },
  { key: 'companies', label: '会社' },
  { key: 'rules', label: '承認ルール' },
  { key: 'settings', label: '設定' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

export default function MastersPage() {
  const [tab, setTab] = useState<TabKey>('accounts');
  const { loading, error } = useMasters();

  if (loading) return <section className="screen"><div className="card"><p className="empty">マスタを読み込み中…</p></div></section>;
  if (error) {
    return (
      <section className="screen">
        <div className="card">
          <h3>マスタを読み込めませんでした</h3>
          <p className="hint">{error}</p>
        </div>
      </section>
    );
  }

  return (
    // master-screen: スマホではタブを横スクロールの1行にし、表は表内だけ横スクロールさせる
    // (列が1文字ずつ折り返して読めなくなるのを防ぐ。2026-08-31 指示)
    <section className="screen master-screen">
      <div className="tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`tab${tab === t.key ? ' on' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'accounts' && <AccountsTab />}
      {tab === 'users' && <UsersTab />}
      {tab === 'departments' && <DepartmentsTab />}
      {tab === 'vendors' && <VendorsTab />}
      {tab === 'payment_accounts' && <PaymentAccountsTab />}
      {tab === 'permissions' && <PermissionsTab />}
      {tab === 'hierarchy' && <HierarchyTab />}
      {tab === 'companies' && <CompaniesTab />}
      {tab === 'rules' && <ApprovalRulesTab />}
      {tab === 'settings' && <SettingsTab />}
    </section>
  );
}
